import { useState, useContext, useRef, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Modal, FilledInput, Typography, Button, FormGroup, FormLabel, FormControl, Box, Grid, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { useHistory } from 'react-router-dom';

import WeekPicker from '../../common/week-picker';

import themeColors from '../../assets/colors';
import { get, post } from '../../utils/api-services';
import helpers from '../../utils/helpers';
import AuthContext from '../../context';

const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: themeColors.background.default,
        padding: 20,
        width: '70%',
        borderRadius: 10
    },
    store: {
        marginLeft: 15,
        backgroundColor: '#0d6efd',
        borderColor: '#0d6efd',
        '&:hover': {
            backgroundColor: '#0d6efd',
            borderColor: '#0d6efd',
            boxShadow: 'none',
        }
    },
    bottom: {
        display: 'flex',
        alignSelf: 'flex-end',
    }
}));

const CreateCheck = ({ open, onClose }) => {

    const classes = useStyles();
    const { showToast, signOut, showLoader } = useContext(AuthContext);
    const history = useHistory();
    const isMounted = useRef(false);
    const [showWeekPicker, setShowWeekPicker] = useState(false);
    const [state, setState] = useState({
        suppliers: [],
        check: {
            week: '',
            start: '',
            end: '',
            supplier: { id: 0, name: 'All suppliers' }
        }
    });

    useEffect(() => {
        if (open && !isMounted.current) {
            makeRequest();
            isMounted.current = true;
        }
    }, [open]);

    const makeRequest = async () => {
        showLoader(true);
        const response = await get('/check/create');
        if (response.status === 200) {
            setState(prev => ({ ...prev, suppliers: response?.suppliers ?? [] }));
        } else {
            console.log('[CreateCheck] makeRequest error', response);
            helpers.failRequest(response, showToast, signOut);
        }
        showLoader(false);
    }

    const handleChange = ({ target }) => setState(prev => ({ ...prev, check: { ...prev.check, [target.name]: target.value } }));

    const handleAutocomplete = (key, value) => setState(prev => ({ ...prev, check: { ...prev.check, [key]: value } }));

    const validateForm = () => {
        const { week } = state.check;

        if (week) {
            store();
        } else {
            showToast('You must select a week', 'error');
        }
    }

    const store = async () => {
        showLoader(true);
        const response = await post('/check/store', state.check);
        if (response.status === 200) {
            history.push(`/ticket/checks/${response.idcheck ? response.idcheck : 'list'}`);
            showToast(response.message);
        } else {
            console.log('[CreateChecks] store error', response);
            helpers.failRequest(response, showToast, signOut);
        }
        showLoader(false);
    }

    const setWeek = ({ week, start, end }) => {
        setShowWeekPicker(false);
        setState(prev => ({ ...prev, check: { ...prev.check, week, start, end } }));
    }

    return (
        <Modal
            open={open}
            onClose={onClose}
            className={classes.root}
        >
            <div className={classes.container}>
                <Typography variant='h2'>{'Create payment'}</Typography>
                <Grid container>
                    <Grid item xs={12} md={6} lg={6}>
                        <FormGroup>
                            <FormLabel>{'Week'}</FormLabel>
                            <FormControl
                                variant='filled'
                                component={Box}
                                width='100%'
                                onClick={() => setShowWeekPicker(true)}
                            >
                                <FilledInput
                                    readOnly
                                    type='text'
                                    placeholder='Select a week'
                                    name='week'
                                    value={state.check.week}
                                    onChange={handleChange}
                                />
                            </FormControl>
                        </FormGroup>
                    </Grid>
                    <Grid item xs={12} md={6} lg={6}>
                        <FormGroup>
                            <FormLabel>{'Supplier'}</FormLabel>
                            <Autocomplete
                                options={state.suppliers}
                                value={state.check.supplier}
                                getOptionLabel={option => option?.name ?? ''}
                                getOptionSelected={(option, value) => option.id === value.id}
                                onChange={(e, value) => handleAutocomplete('supplier', value)}
                                renderInput={params => <TextField {...params} placeholder='Supplier' />}
                            />
                        </FormGroup>
                    </Grid>
                </Grid>
                <div className={classes.bottom}>
                    <Button
                        variant='contained'
                        color='secondary'
                        onClick={onClose}
                    >
                        {'Cancel'}
                    </Button>
                    <Button
                        variant='contained'
                        className={classes.store}
                        onClick={validateForm}
                    >
                        {'Store'}
                    </Button>
                </div>

                <WeekPicker
                    open={showWeekPicker}
                    onClose={() => setShowWeekPicker(false)}
                    setWeek={setWeek}
                />
            </div>
        </Modal>
    );
}

export default CreateCheck;